/**
 * Strips any exchange prefix (e.g. "XYZ:", "ABC:") from a base asset string.
 * Also removes trailing "-PERP" and "-SWAP" suffixes.
 *
 * "XYZ:GOLD" → "GOLD", "BTC" → "BTC", "ETH-PERP" → "ETH"
 */
export function stripExchangePrefix(baseAsset: string): string {
  return baseAsset
    .replace(/^[a-zA-Z]+:/, "")
    .replace(/-PERP$/, "")
    .replace(/-SWAP$/, "");
}

/**
 * Returns the token icon URL for a given base asset on a specific exchange.
 * Delegates to per-exchange adapters for CDN URL formatting.
 */
export { getExchangeTokenIconUrl } from "./market-adapters/token-icons";
